module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }